import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "card"]

  sort(event) {
    const field = event.currentTarget.dataset.sortField
    const cards = Array.from(this.cardTargets)
    const button = event.currentTarget
    const direction = button.querySelector('.sort-direction')
    const isAscending = direction.classList.contains('opacity-0') || direction.textContent === '↓'

    // Reset all other sort indicators
    this.element.querySelectorAll('.sort-direction').forEach(dir => {
      if (dir !== direction) {
        dir.textContent = '↑'
        dir.classList.add('opacity-0')
      }
    })

    // Update current sort indicator
    direction.classList.remove('opacity-0')
    direction.textContent = isAscending ? '↑' : '↓'

    cards.sort((a, b) => {
      let valueA, valueB

      if (field === 'position' || field === 'name') {
        valueA = a.querySelector(field === 'position' ? '.text-sm.text-gray-600' : '.font-semibold').textContent.trim()
        valueB = b.querySelector(field === 'position' ? '.text-sm.text-gray-600' : '.font-semibold').textContent.trim()
        return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
      } else {
        valueA = parseInt(a.dataset[field]) || 0
        valueB = parseInt(b.dataset[field]) || 0
        return isAscending ? valueA - valueB : valueB - valueA
      }
    })

    this.containerTarget.innerHTML = ''
    cards.forEach(card => this.containerTarget.appendChild(card))
  }
} 